import styled from "styled-components";
import { darkModeColors } from "../../consts";
import FlexContainers from "./FlexContainers";
import WrapperContainer from "./WrapperContainer";

export const PageContainer = styled(WrapperContainer)`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;

  width: ${(props) => (props?.width ? props.width : `calc(100% - 96px)`)};
  height: auto;
  max-height: 100vh;
  ${(props) => props?.justifyContent && `justify-content: ${props?.justifyContent}`};

  overflow-y: auto;
  position: relative;

  padding: 32px;
`;

export const WhiteContainer = styled(FlexContainers.FlexColumnCenter)`
  background: ${darkModeColors.WHITE_RAISIN_100};

  border: ${(props) => props?.theme?.darkMode && `1px solid rgba(110, 110, 116, 0.55)`};
  box-shadow: ${(props) =>
    props?.theme?.darkMode
      ? `0px 4px 4px rgba(0, 0, 0, 0.16)`
      : `0px 6px 6px rgba(237, 238, 241, 0.6)`};

  border-radius: 16px;
`;
